module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-up-black.fdabcc55.svg";